"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _WorkspaceActions = require("../actions/WorkspaceActions");

var _SortDirections = _interopRequireDefault(require("settings-ui-lib/constants/SortDirections"));

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _WorkspaceMember = _interopRequireDefault(require("../records/WorkspaceMember"));

var _Workspace = require("../records/Workspace");

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  sortCol: 'name',
  sortDir: _SortDirections.default.ASCENDING,
  selectedMembers: (0, _immutable.Set)(),
  selectedWorkspaceMembers: (0, _immutable.List)(),
  teams: (0, _immutable.Map)(),
  users: (0, _immutable.Map)()
});

function buildMembersList(workspace, teams, users) {
  var teamMembers = (0, _immutable.List)(workspace.teamMemberIds).map(function (id) {
    var team = teams.get(id);
    return new _WorkspaceMember.default({
      id: id,
      memberType: 'team',
      name: team.name,
      usersCount: team.memberIds.length
    });
  });
  var userMembers = (0, _immutable.List)(workspace.userMemberIds).map(function (id) {
    var user = users.get(id);
    var name = _I18n.default.formatName({
      firstName: user.firstName,
      lastName: user.lastName
    }) || user.email;
    return new _WorkspaceMember.default({
      id: id,
      memberType: 'user',
      name: name,
      usersCount: 1
    });
  });
  return teamMembers.concat(userMembers);
}

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _WorkspaceActions.WorkspaceActionTypes.SELECT_WORKSPACE, function (state, action) {
  var workspace = action.payload.workspace;

  if (!workspace) {
    return initialState;
  }

  var allMembers = buildMembersList(workspace, action.payload.teams, action.payload.users);
  return state.set('selectedWorkspace', workspace).set('selectedWorkspaceMembers', allMembers).set('teams', action.payload.teams).set('users', action.payload.users);
}), (0, _defineProperty2.default)(_handleActions, _WorkspaceActions.WorkspaceActionTypes.SELECT_MEMBER_FOR_DELETE, function (state, action) {
  var memberKey = action.payload.memberKey;
  return state.update('selectedMembers', function (selectedMembers) {
    return selectedMembers.add(memberKey);
  });
}), (0, _defineProperty2.default)(_handleActions, _WorkspaceActions.WorkspaceActionTypes.DESELECT_MEMBER_FOR_DELETE, function (state, action) {
  var memberKey = action.payload.memberKey;
  return state.update('selectedMembers', function (selectedMembers) {
    return selectedMembers.remove(memberKey);
  });
}), (0, _defineProperty2.default)(_handleActions, _WorkspaceActions.WorkspaceActionTypes.SELECT_ALL_MEMBERS_FOR_DELETE, function (state, action) {
  var memberKeys = action.payload.memberKeys;
  return state.mergeIn(['selectedMembers'], (0, _immutable.fromJS)(memberKeys));
}), (0, _defineProperty2.default)(_handleActions, _WorkspaceActions.WorkspaceActionTypes.DESELECT_ALL_MEMBERS_FOR_DELETE, function (state) {
  return state.set('selectedMembers', (0, _immutable.Set)());
}), (0, _defineProperty2.default)(_handleActions, _WorkspaceActions.DeleteWorkspaceMembersActionTypes.SUCCESS, function (state, action) {
  var workspace = new _Workspace.fromJSON(action.payload.data.workspace);
  var allMembers = buildMembersList(workspace, state.get('teams'), state.get('users'));
  return state.set('selectedWorkspace', workspace).set('selectedMembers', (0, _immutable.Set)()).set('selectedWorkspaceMembers', allMembers);
}), (0, _defineProperty2.default)(_handleActions, _WorkspaceActions.RenameWorkspaceActionTypes.SUCCESS, function (state, action) {
  var workspace = new _Workspace.fromJSON(action.payload.data.workspace);
  return state.update('selectedWorkspace', function (selectedWorkspace) {
    return selectedWorkspace ? selectedWorkspace.set('name', workspace.name) : selectedWorkspace;
  });
}), (0, _defineProperty2.default)(_handleActions, _WorkspaceActions.AddWorkspaceMembersActionTypes.SUCCESS, function (state, action) {
  var workspace = new _Workspace.fromJSON(action.payload.data.workspace);
  var allMembers = buildMembersList(workspace, state.get('teams'), state.get('users'));
  return state.set('selectedWorkspace', workspace).set('selectedMembers', (0, _immutable.Set)()).set('selectedWorkspaceMembers', allMembers);
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;